// extracted by mini-css-extract-plugin
export var centerText = "_b9-8";
export var container = "_b9-0";
export var doughnutContainer = "_b9-7";
export var legend = "_b9-a";
export var legendItemColorDisplay = "_b9-b";
export var legendItemLabel = "_b9-d";
export var legendItemValue = "_b9-c";
export var lg = "_b9-5";
export var maxWidth = "_b9-9";
export var md = "_b9-4";
export var responsive = "_b9-6";
export var sm = "_b9-3";
export var xs = "_b9-2";
export var xxs = "_b9-1";